import { Component, OnInit, NgZone } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { Router } from '@angular/router';
import { ApiService } from '../services/api/api.service';
import { AlertService } from '../services/alert/alert.service';
import { File } from '@ionic-native/file/ngx';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer/ngx';
import { DomSanitizer } from '@angular/platform-browser';


declare var Ionic: any
@Component({
  selector: 'app-cart',
  templateUrl: './cart.page.html',
  styleUrls: ['./cart.page.scss'],
})
export class CartPage implements OnInit {
  emptyCart:any = "../../assets/img/empty-cart.png";
  myDiscountIcon:any = "../../assets/img/offer_bg.svg";
  isCartEmpty:any = false
  catgItemList:any = []
  orderId:any = ''
  onApiCall:any = false
  filelocation:any = ''
  DownloadPath:any = ''
  instructions:any = ''
  tipFrRider:any = 0

  subTotalShow:any = ''
  grandTotalShow:any = ''
  tipData:any = [{ "name" : 0, "isSelected": true},{ "name" : 5, "isSelected": false},{ "name" : 10, "isSelected": false},{ "name" : 15, "isSelected": false}]
  constructor(
    public toastController: ToastController,
    private router: Router,
    public api: ApiService,
    public alert: AlertService,
    private file: File,
    private transfer: FileTransfer,
    private sanitizer: DomSanitizer,
    public zone: NgZone) { 
      // this.DownloadPath = this.api.getDownloadPath();
    }

  ngOnInit() {
    this.zone.run(() => {
      try {
        this.api.getCartItemList().subscribe((result:any) => {
          if(result.status == true){
            if(result.data.length > 0){
              this.orderId = result.data[0].id
              localStorage.setItem("order_id",this.orderId)
              this.catgItemList = result.data[0].cart_items
              if(result.data[0].cart_items.cart_items.length == 0){
                this.isCartEmpty = true
              }
              else{
                this.subTotalShow = this.catgItemList.sub_total
                this.grandTotalShow = this.catgItemList.grant_total
              }
              this.getStoreDetails(result.data[0].store_id)
            }
            else{
              this.isCartEmpty = true
            }
          }
        },(err)=>{
          this.isCartEmpty = true
          console.log(err)
        });
      }
      catch (error) {
        console.error('Here is the error message', error);
      }
    })
  }

  selectTipPercent(index:any){
    for(let i = 0;i < this.tipData.length;i++){
      if(index == i){
        this.tipData[i].isSelected = true
      }
      else{
        this.tipData[i].isSelected = false
      }
    }

    this.reCalculate()
  }

  reCalculate(){
    for(let i = 0;i < this.tipData.length;i++){
      if(this.tipData[i].isSelected == true){
        this.tipFrRider = JSON.parse(this.catgItemList.sub_total) * (this.tipData[i].name/100)
        this.grandTotalShow = JSON.parse(this.catgItemList.grant_total) + JSON.parse(this.tipFrRider)
      }
    }
  }

  clearAll(){
    let requestData:any = {
      "device_token": localStorage.getItem("uuid")
    }
    try {
      this.api.removeAllProductFromCart(requestData).subscribe((result:any) => {
        if(result.status == true){
          this.isCartEmpty = true
        }
      },(err)=>{
        console.log(err)
      });
    }
    catch (error) {
      console.error('Here is the error message', error);
    }
  }

  reduceQuantity(value:any,index:any){
    this.zone.run(() => {
      this.onApiCall = true
      if(value.price_details[0].start_to_show == value.quantity){
        this.onApiCall = true
        let requestData:any = {
          "device_token": localStorage.getItem("uuid"),
          "quantity": value.quantity - 1,
          "product_id": value.product,
          "price_mapping_id": value.price_mapping
          }
        try {
          this.api.addProductTocart(requestData).subscribe((result:any) => {
            if(result.status == true){
              // let responseData:any = result.data.cart_items
                    this.catgItemList.cart_items.splice(index,1)
                    this.catgItemList.sub_total = result.data.cart_items.sub_total
                    this.catgItemList.grant_total = result.data.cart_items.grant_total
                    this.catgItemList.discount = result.data.cart_items.discount
                    this.catgItemList.discount_percent = result.data.cart_items.discount_percent
                    this.catgItemList.discount_percentage = result.data.cart_items.discount_percentage
                    this.reCalculate()
                    this.onApiCall = false
                    if(this.catgItemList.cart_items.length == 0){
                      this.isCartEmpty = true
                    }
                    return
            }
          },(err)=>{
            this.onApiCall = false
            console.log(err)
          });
        }
        catch (error) {
          this.onApiCall = false
          console.error('Here is the error message', error);
        }
        // let requestData:any = {
        //   "device_token": localStorage.getItem("uuid"),
        //   "order_id": this.orderId,
        //   "product_id": value.product,
        //   "cart_id": value.id
        //   }
        // try {
        //   this.api.removeProductFromCart(requestData).subscribe((result:any) => {
        //     if(result.status == true){
        //       this.catgItemList.cart_items.splice(index,1)
        //       this.catgItemList.sub_total = result.data.cart_items.sub_total
        //       this.catgItemList.grant_total = result.data.cart_items.grant_total
        //       this.onApiCall = false
        //       if(this.catgItemList.cart_items.length == 0){
        //         this.isCartEmpty = true
        //       }
        //       // console.log(this.catgItemList)
        //     }
        //   },(err)=>{
        //     this.onApiCall = false
        //     console.log(err)
        //   });
        // }
        // catch (error) {
        //   this.onApiCall = false
        //   console.error('Here is the error message', error);
        // }
      }
      else if(value.quantity > value.price_details[0].start_to_show){
        this.onApiCall = true
        let requestData:any = {
          "device_token": localStorage.getItem("uuid"),
          "quantity": value.quantity - 1,
          "product_id": value.product,
          "price_mapping_id": value.price_mapping
          }
        try {
          this.api.addProductTocart(requestData).subscribe((result:any) => {
            if(result.status == true){
              let responseData:any = result.data.cart_items
              if(responseData.cart_items.length > 0){
                for(let i = 0;i < responseData.cart_items.length; i++){
                  if(responseData.cart_items[i].product == requestData.product_id && responseData.cart_items[i].price_mapping == requestData.price_mapping_id){
                    this.catgItemList.cart_items[index].quantity = responseData.cart_items[i].quantity
                    this.catgItemList.cart_items[index].price_details[0].price = responseData.cart_items[i].price_details[0].price
                    this.catgItemList.cart_items[index].price_details[0].discount_percentage_with_amt = responseData.cart_items[i].price_details[0].discount_percentage_with_amt
                    this.catgItemList.cart_items[index].price_details[0].you_save = responseData.cart_items[i].price_details[0].you_save
                    this.catgItemList.cart_items[index].price_details[0].unit_display = responseData.cart_items[i].price_details[0].unit_display
                    this.onApiCall = false
                    this.catgItemList.sub_total = responseData.sub_total
                    this.catgItemList.grant_total = responseData.grant_total
                    this.reCalculate()
                    this.catgItemList.discount = responseData.discount
                    this.catgItemList.discount_percent = responseData.discount_percent
                    this.catgItemList.discount_percentage = responseData.discount_percentage
                    return
                  }
                }
              }
            }
          },(err)=>{
            this.onApiCall = false
            console.log(err)
          });
        }
        catch (error) {
          this.onApiCall = false
          console.error('Here is the error message', error);
        }
      }
    })
  }

  addQuantity(value:any,index:any){
    this.zone.run(() => {
      this.onApiCall = true
      let requestData:any = {
        "device_token": localStorage.getItem("uuid"),
        "quantity": value.quantity + 1,
        "product_id": value.product,
        "price_mapping_id": value.price_mapping
        }
      try {
        this.api.addProductTocart(requestData).subscribe((result:any) => {
          if(result.status == true){
            let responseData:any = result.data.cart_items
            if(responseData.cart_items.length > 0){
              for(let i = 0;i < responseData.cart_items.length; i++){
                if(responseData.cart_items[i].product == requestData.product_id && responseData.cart_items[i].price_mapping == requestData.price_mapping_id){
                  this.catgItemList.cart_items[index].quantity = responseData.cart_items[i].quantity
                  this.catgItemList.cart_items[index].price_details[0].price = responseData.cart_items[i].price_details[0].price
                  this.catgItemList.cart_items[index].price_details[0].discount_percentage_with_amt = responseData.cart_items[i].price_details[0].discount_percentage_with_amt
                  this.catgItemList.cart_items[index].price_details[0].you_save = responseData.cart_items[i].price_details[0].you_save
                  this.catgItemList.cart_items[index].price_details[0].unit_display = responseData.cart_items[i].price_details[0].unit_display
                  this.onApiCall = false
                  this.catgItemList.sub_total = responseData.sub_total
                  this.catgItemList.grant_total = responseData.grant_total
                  this.reCalculate()
                  this.catgItemList.discount = responseData.discount
                  this.catgItemList.discount_percent = responseData.discount_percent
                  this.catgItemList.discount_percentage = responseData.discount_percentage
                  return
                }
              }
            }
          }
        },(err)=>{
          this.onApiCall = false
          console.log(err)
        });
      }
      catch (error) {
        this.onApiCall = false
        console.error('Here is the error message', error);
      }
    })
  }

  convertToPrice(value:any){
    return value.toFixed(2)
  }

  removeFromCart(index:any){
    this.catgItemList.splice(index,1)
  }

  removeItemFromCart(value:any,index:any){
    this.onApiCall = true
    let requestData:any = {
      "device_token": localStorage.getItem("uuid"),
      "order_id": this.orderId,
      "product_id": value.product,
      "cart_id": value.id
      }
    this.api.removeProductFromCart(requestData).subscribe((result:any) => {
      if(result.status == true){
          this.catgItemList.cart_items.splice(index,1)
          this.catgItemList.sub_total = result.data.cart_items.sub_total
          this.catgItemList.grant_total = result.data.cart_items.grant_total
          this.catgItemList.discount = result.data.cart_items.discount
          this.catgItemList.discount_percent = result.data.cart_items.discount_percent
          this.catgItemList.discount_percentage = result.data.cart_items.discount_percentage
          this.reCalculate()
          this.onApiCall = false
          if(this.catgItemList.cart_items.length == 0){
            this.isCartEmpty = true
          }
      }
      else{
        this.onApiCall = false
      }
    },(err)=>{
      this.onApiCall = false
      console.log(err)
    });
  }

  getStoreDetails(storeId: any){
    localStorage.setItem('cart-store-id',storeId)
    this.api.getStoreDetailsWithId(storeId).subscribe(async(result:any) => {
      if(result.status == true){
        if(result.data.length > 0){ 
          localStorage.setItem('cart-subscriber-id',result.data[0].subscriber)
          if(result.data[0].default_delivery_charge != null && result.data[0].default_delivery_charge != 'null' && result.data[0].default_delivery_charge != ''){
            localStorage.setItem('delivery-charge',JSON.stringify(JSON.parse(result.data[0].default_delivery_charge)))
          }
          else{
            localStorage.setItem('delivery-charge','0')
          }
        }
      }
    })
  }

  placeOrder(){
    
    // if(this.tipFrRider != '' || this.tipFrRider != undefined || this.tipFrRider != null){
    //   let temp:any = JSON.stringify(JSON.parse(this.tipFrRider)).split('.')
    //   if(temp.length > 3){
    //     this.alert.presentAlert('Alert','','Please enter a valid tip amount')
    //     return
    //   }
    // }

    if(this.tipFrRider == ''){
      this.tipFrRider = 0
    }

    // let requestData:any = {
    //   "amount": this.grandTotalShow
    // }
    // this.api.minOrderCheck(requestData).subscribe((result:any) => {
    //   if(result.status == true){
        let data:any = {
          grand_total : this.catgItemList.grant_total,
          sub_total : this.catgItemList.sub_total,
          discount : this.catgItemList.discount,
          discount_percent : this.catgItemList.discount_percent,
          discount_percentage: this.catgItemList.discount_percentage,
          current_currency_symbol: this.catgItemList.current_currency_symbol,
          comments:this.instructions,
          tip: this.tipFrRider,
          amount: this.grandTotalShow
        }
        this.router.navigate(['/shipping', data])
    //   }
    //   else {
    //     this.alert.presentAlert('Alert','',result.message)
    //   }
    // })
  }

  convertPrice(value:any){
    return JSON.parse(value).toFixed(2);
  }

  goToShop(){
    let value:any = '' 
    this.router.navigate(['/'+value])
  }

  // checkDirectory(fileName:any,url:any){
  //   this.file.checkFile(this.file.cacheDirectory, fileName).then(_ => console.log('File exists')).catch((err:any)=>{
  //     console.log("File doesn't exist");
  //     this.downloadImages(fileName,url)
  //   });
  // }
  
  // tempFileCheck:any = false
  // async downloadImages(fileName:any,url:any) {
  //   return new Promise((resolve, reject) => {
  //     const fileTransfer: FileTransferObject = this.transfer.create();
  //     let data = [];
  //     data.push(new Promise((resolve, reject) => {
  //     resolve( fileTransfer.download(url, this.file.cacheDirectory + fileName).then((entry) => {
  //       this.tempFileCheck = true
  //     console.log('download complete: ' + entry.toURL());
  //     }))
  //   }))
  //     Promise.all(data).then((values) => {
  //         resolve(values)
  //     });
  //   })
  // }

  // openImage(img:any){
  //   let imgFileName:any = img
  //   imgFileName = imgFileName.split('/')
  //   imgFileName = imgFileName[imgFileName.length-1]
  //   return Ionic.WebView.convertFileSrc(this.file.cacheDirectory+imgFileName)
  // }

  // OnChange(){
  //   setTimeout(() => {
  //     console.log(this.tipFrRider)
  //     this.subTotalShow = JSON.parse(this.tipFrRider) + JSON.parse(this.subTotalShow)
  //     this.grandTotalShow = JSON.parse(this.tipFrRider) + JSON.parse(this.grandTotalShow)
  //   }, 1000);
  // }

}
